/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlEntityRelation = {
    Freemium: 'freemium',
    Policyholder: 'policyholder',
    General: 'general',
    Re: 're',
    WhiteLabel: 'white_label'
} as const;
export type ControlEntityRelation = typeof ControlEntityRelation[keyof typeof ControlEntityRelation];


export function ControlEntityRelationFromJSON(json: any): ControlEntityRelation {
    return ControlEntityRelationFromJSONTyped(json, false);
}

export function ControlEntityRelationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityRelation {
    return json as ControlEntityRelation;
}

export function ControlEntityRelationToJSON(value?: ControlEntityRelation | null): any {
    return value as any;
}

